// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mKOr","largestCol":"styles_largestCol__2pgA9","smallestCol":"styles_smallestCol__23hR9"};